var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgT = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 131 71"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.5,
  cy: 61.5,
  r: 9.5,
  fill: "#000"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 109.5,
  cy: 61.5,
  r: 9.5,
  fill: "#000"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 64.5,
  cy: 56.5,
  r: 14.5,
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M4.387 27a3 3 0 0 0-2.998 2.885l-.77 20A3 3 0 0 0 3.619 53h8.393c2.476-3.05 6.255-5 10.489-5s8.014 1.95 10.489 5h2.388a3 3 0 0 0 2.973-2.6l2.692-20A3 3 0 0 0 38.07 27zM54 0a4 4 0 0 0-4 4v38.009A20.44 20.44 0 0 1 64.5 36c10.129 0 18.542 7.346 20.202 17h11.834c2.77-4.216 7.542-7 12.964-7s10.193 2.784 12.964 7h1.949a4 4 0 0 0 3.976-3.566l2.127-19.5a4 4 0 0 0-3.976-4.434h-23.002a4 4 0 0 1-3.619-2.297L90.081 2.297A4 4 0 0 0 86.46 0zm4 7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h32.923a2 2 0 0 0 1.827-2.812l-6.222-14A2 2 0 0 0 84.7 7z",
  clipRule: "evenodd"
})));
export default SvgT;